<script lang="ts" setup>
import { useStakeAccountStore } from '~/store/stake-accounts'

const { dialog = false } = defineProps<{
  dialog?: boolean
}>()

const setTab = inject<(tabName: string) => void>('setTab')
const accountsStore = useStakeAccountStore()

function tabHandler() {
  if (dialog) {
    accountsStore.stakeDialog = true
    return
  }
  if (setTab) {
    setTab('Stake')
  }
}
</script>

<template>
  <div class="wallet-not-stakes">
    <div class="wallet-not-stakes__body">
      <i-app-coinstack-off />

      <span data-name="title" class="text-sm">No Stakes Found</span>
      <span data-name="desc" class="text-sm">You currently don't have any stakes with us. There's nothing to unstake at the moment.</span>
    </div>
    <div class="wallet-not-stakes__action square-block">
      <app-btn
        variant="outline"
        class="stake-btn"
        @click="tabHandler"
      >
        Stake now
      </app-btn>
    </div>
  </div>
</template>

<style lang="scss">
.wallet-not-stakes {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  height: 100%;

  &__body {
    padding: 32px;
    gap: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;

    svg {
      width: 48px;
      height: 48px;
      color: $black;
      margin-bottom: 28px;
    }

    span[data-name='title'] {
      font-size: 18px;
      font-weight: 700;
    }

    span[data-name='desc'] {
      font-size: 16px;
      font-weight: 500;
      line-height: normal;
      max-width: 250px;
    }
  }
  &__action {
    .stake-btn {
      width: 240px;
      min-height: 44px;

      @media (max-width: $breakpoint-xs) {
        width: 140px;
        min-height: 28px;
      }
    }
  }
}
</style>
